import { AxiosInstance } from 'axios'
import { createOptimizedAPI } from '../utils'

export interface IVSMWelcomeWidgetStatus {
  dismissed: string | null;
}

export function vsmWelcomeWidgetApiFactory(api: AxiosInstance) {
  const baseUrl = '/web/api/v2/vsm-welcome-widget'
  const methods = {
    getVSMWelcomeWidgetStatus() {
      return api.get<IVSMWelcomeWidgetStatus>(baseUrl)
    },
    dismissVSMWelcomeWidget() {
      return api.post<IVSMWelcomeWidgetStatus>(baseUrl)
    }
  }
  return createOptimizedAPI(methods)
}
